import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./WhoIsItFor.scss";
import useTheme from "../../components/useTheme/useTheme";
import { registrationFormURL } from "../../components/helpers/constant-words";

const sectionsData = [
  {
    id: 1,
    heading: "Business/ Firm Owners",
    description:
      "Find consultants, products, materials and services for your projects, all in one place. Connect on demand, use the Ask Anything WhatsApp bot for quick answers, and explore more on Archinza Web.",
    tags: ["Design & Consult", "Manufacture & Resell", "Support Design"],
    image: "/Personal/Owner.png",
    buttonText: "Get Started on Archinza Web",
  },
  {
    id: 2,
    heading: "Working Professionals",
    description:
      "Save time with AI-powered search tailored to projects and product needs. Get instant answers to design queries on WhatsApp, explore relevant job opportunities, and upskill all without endless browsing.",
    tags: ["Verified Vendors", "Transparent Pricing", "Quick Connect"],
    image: "/Personal/Working.png",
    buttonText: "Explore Vendors",
  },
  {
    id: 3,
    heading: "Freelancer/ Artists",
    description:
      "Find partners, products, materials and service providers for your creation. Connect on demand, use the Ask Anything WhatsApp bot for quick answers, and explore more on Archinza Web.",
    tags: ["Beautiful Profiles", "Easy Updates", "SEO Ready"],
    image: "/Personal/Artist.png",
    buttonText: "Showcase Now",
  },
  {
    id: 4,
    heading: "Students",
    description:
      "Find courses, resources, materials, products and projects to explore, all in one place. Get quick answers with the Ask Anything WhatsApp bot, and explore more on Archinza Web.",
    tags: ["Beautiful Profiles", "Easy Updates", "SEO Ready"],
    image: "/Personal/Students.png",
    buttonText: "Showcase Now",
  },
  {
    id: 5,
    heading: "Homeowners / DIY Enthusiast",
    description:
      "Looking to upgrade your space? Discover architects and designers, products and materials for your projects. Get quick answers with the Ask Anything WhatsApp bot, and explore more on Archinza Web.",
    tags: ["Beautiful Profiles", "Easy Updates", "SEO Ready"],
    image: "/Personal/Home.png",
    buttonText: "Showcase Now",
  },
];

const WhoIsItFor = () => {
  const { theme } = useTheme();
  return (
    <section className="who-is-it-for">
      {/* Header */}
      <div
        className="who-is-it-for__header"
        style={{
          backgroundColor: theme === "dark" ? "#ffffff1a" : "",
          color: theme === "dark" ? "#ffffffcc" : "",
        }}
      >
        <h2
          className="who-is-it-for__title"
          style={{
            color: theme === "dark" ? "#ffffff" : "",
          }}
        >
          Archinza is for everyone
        </h2>
        <p
          className="who-is-it-for__subtitle"
          style={{
            color: theme === "dark" ? "#ffffff" : "",
          }}
        >
          Dive in for free and explore products, materials, and professionals for your project.
        </p>
      </div>

      <div className="who-is-it-for__container">
        {sectionsData.map((section, index) => (
          <div
            key={section.id}
            className={`who-is-it-for__section ${
              index % 2 !== 0 ? "who-is-it-for__section--reverse" : ""
            }`}
          >
            {/* Text Section */}
            <div className="who-is-it-for__text-section">
              <div className="who-is-it-for__text-content">
                <h1
                  className="who-is-it-for__section-title"
                  style={{
                    color: theme === "dark" ? "#ffffff" : "",
                  }}
                >
                  {section.heading}
                </h1>
                <p
                  className="who-is-it-for__section-description"
                  style={{
                    color: theme === "dark" ? "#ffffff" : "",
                  }}
                >
                  {section.description}
                </p>
                <div className="who-is-it-for__button-wrapper">
                  <Link to={registrationFormURL}>
                    <button className="who-is-it-for__primary-button">
                      Get Started
                      <ArrowRight className="who-is-it-for__arrow-icon" />
                    </button>
                  </Link>
                  <span className="who-is-it-for__button-subtext">Free for a limited time only</span>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="who-is-it-for__image-section">
              <img
                src={section.image}
                alt={section.heading}
                className="who-is-it-for__image"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhoIsItFor;
